import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Order matters: fonts -> tokens -> globals. gt-tokens.css began as a verbatim
// copy of the design prototype's own gt-tokens.css and is now the app's single
// source of truth for every token. The prototype keeps its own copy (upstream-
// owned, mirrored in design/), so the two can drift — if a token disagrees,
// this file wins for the app and the difference is a design change to raise.
import './styles/fonts.css';
import './styles/gt-tokens.css';
import './styles/global.css';

import { App } from './App';
import { isGalleryRoute } from './dev/Gallery.tsx';
import { browserHistoryEnv, initHistorySync } from './store/history.ts';
import { useQd } from './store/index.ts';
import { browserResumeEnv, initResumeSync } from './store/resume.ts';

// Still no router: this only mirrors nav depth into `history.state` so the OS
// back gesture closes one level instead of leaving the site. The URL never
// changes — except at `/dev/gallery`, where the gallery owns the path and this
// stays out of the way.
if (typeof window !== 'undefined' && !(import.meta.env.DEV && isGalleryRoute())) {
  initHistorySync(useQd, browserHistoryEnv());
  // And still no router: this keeps the screen + scroll offset in localStorage
  // so a reload (a phone evicting the tab, a pull-to-refresh) comes back to
  // where it left. `boot()` reads it; this only writes.
  initResumeSync(useQd, browserResumeEnv());
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root is missing from index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
